module.exports = __webpack_public_path__ + "images/pages/lp/estimate_process_1_42aae685a1f6df86d28e8e720e871e44.png";